import { ClientItemDto } from './client-item-dto';

export class ClientListDto
{
    clientDtoList: ClientItemDto[];
    requestId:String;
}